import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import ProductCard from './product-card';
import ReactPaginate from 'react-paginate';
import chunk from 'lodash/chunk';


class Products extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      reset:false,
      current:0,
      totalCount:18, //products per page
    }

    this.handlePageClick = this.handlePageClick.bind(this);

  }

  handlePageClick = (data) => {
    let selected = data.selected;
    this.setState({current: selected, reset:false});
    window.scrollTo({
      top: ReactDOM.findDOMNode(this).getBoundingClientRect().top,
      left: 0,
      behavior: 'smooth'
    });
  }


  render(){

    if(this.props.data.length === 0){
      return (
        <div className="products">
          <div className="row">
            <div className="columns small-12">
              <p>Oops no products matching your selection, please re-apply filters</p>
            </div>
          </div>
        </div>
      )
    }else{

      let newChuck = chunk(this.props.data, this.state.totalCount);

      return (
          <div className="search-products">
            <div className="row">
                { newChuck[this.state.current].map((product) => { return <ProductCard data={product} key={product.sys.id} /> }) }
            </div>

            <div className="row">
              <div className="columns small-12">

              <ReactPaginate previousLabel={<span className="fa fa fa-chevron-left" /> }
                        nextLabel={<span className="fa fa fa-chevron-right"  />}
                        breakLabel={<a href="">...</a>}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(this.props.data.length / this.state.totalCount)}
                        marginPagesDisplayed={1}
                        forcePage={this.state.current}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
              </div>
            </div>
          </div>
      )
    }
  }

}

export default Products;



// WEBPACK FOOTER //
// ./src/components/tripSearch/products/products.js